import Style from "./css/style.module.css";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function AddTodoArea(props: any) {
  let myProps = {
    sort_data:{},
    add_todo_arr: [],
    set_add_todo_arr: (inData: any) => { },
    add_new_todo_row_by_ajax: (inData: any) => { },
    ...props
  };
  let select_subject_option_arr=XcolumnFunc.getSortByTableKey({'table':'study_title','key':'a_subject_sort'});

  const remove_todo_row = (idx: number) => {
    let change_add_todo_arr = [...myProps.add_todo_arr];
    change_add_todo_arr.splice(idx, 1);
    myProps.set_add_todo_arr(change_add_todo_arr);
  };

  const on_change_todo_row = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      row_num: 0,
      ...inData
    };
    let name = opt_obj.name;
    let value = opt_obj.value;
    let row_num = opt_obj.row_num;
    let change_add_todo_arr = [...myProps.add_todo_arr];
    if (change_add_todo_arr[row_num]) {
      change_add_todo_arr[row_num][name] = value;
    }

    myProps.set_add_todo_arr(change_add_todo_arr);
  };

  const get_add_todo_row_tags = () => {
    let add_todo_row_tags = myProps.add_todo_arr.map((item: any, idx: number) => {
      if(item.a_sort!=myProps.sort_data.sort){
        return "";
      }
      return (
        <tr key={idx}>
          <td>
            <input type="text" className={Style.add_todo_td_input}
              value={item.a_title}
              name="a_title"
              onChange={(e: any) => {
                on_change_todo_row({
                  name: e.target.name,
                  value: e.target.value,
                  row_num: idx
                });
              }} />
          </td>
          <td className="text-center">
              <select className={Style.add_todo_td_input}
                value={item.a_subject}
                name="a_subject"
                onChange={(e: any) => {
                  on_change_todo_row({
                    name: e.target.name,
                    value: e.target.value,
                    row_num: idx
                  });
                }}
                style={{width:60}}
                >
                  <option value="">과목</option>
                {select_subject_option_arr.map((select_opt: any, select_opt_idx: number) => {
                  return (
                    <option key={select_opt_idx} value={select_opt.value}>{select_opt.text}</option>
                  );
                })}
              </select>
          </td>
          <td className="text-center">
            <input type="text" className={Style.add_todo_td_input}
              value={item.a_success_amount}
              name="a_success_amount"
              onChange={(e: any) => {
                on_change_todo_row({
                  name: e.target.name,
                  value: e.target.value,
                  row_num: idx
                });
              }} 
              style={{ width: 50,textAlign:"center" }} />
          </td>
          <td>
            <select className="row-input ml-1" name="a_amount_sort"
              value={item.a_amount_sort}
              onChange={(e: any) => {
                on_change_todo_row({
                  name: e.target.name,
                  value: e.target.value,
                  row_num: idx
                });
              }} style={{ width: 60 }} >
              <option value="페이지">페이지</option>
              <option value="챕터">챕터</option>
              <option value="개">개</option>
              <option value="문제">문제</option>
              <option value="단원">단원</option>
            </select>
          </td>
          <td className="text-left">
            <button className="btn btn-sky"
              onClick={()=>{
                myProps.add_new_todo_row_by_ajax({
                  add_todo_arr:[item],
                });
              }}>작성</button>
            <button className="btn btn-gray ml-1"
              onClick={() => { remove_todo_row(idx); }}>취소</button>
          </td>
        </tr>
      );
    });
    return add_todo_row_tags;
  };

  return (
    <>
      {get_add_todo_row_tags()}
    </>
  );
};
export default AddTodoArea;